import React from "react";

const CopyToClipboard = ({ text }) => {
  const copyToClipboard = () => {
    const el = document.createElement("textarea");
    el.value = text;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);

    const selected =
      document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false;
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);

    if (selected) {
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(selected);
    }
    console.log("Text copied to clipboard");
  };

  return (
    <span
      onClick={copyToClipboard}
      className="text-ribola-dove-gray px-4 py-1 mt-3 cursor-pointer"
    >
      <i className="far fa-copy text-4xl inline-block"></i>
    </span>
  );
};

export default CopyToClipboard;
